// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AutoscrollController from "./autoscroll_controller"
application.register("autoscroll", AutoscrollController)

import CascadeSelectController from "./cascade_select_controller"
application.register("cascade-select", CascadeSelectController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ColorFieldController from "./color_field_controller"
application.register("color-field", ColorFieldController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import OnboardingController from "./onboarding_controller"
application.register("onboarding", OnboardingController)

import StoreTapController from "./store_tap_controller"
application.register("store-tap", StoreTapController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)
